import React, { Component } from "react";
import "./style.scss";
import {
  Layout,
  Table,
  Row,
  Col,
  Card,
  Button,
  PageHeader,
  Statistic,
  Steps,
} from "antd";
import OrderService from "../../services/OrderService";
import R2Footer from "../../components/Footer";

const { Step } = Steps;

const { Content } = Layout;

const columns = [
  {
    title: "Item",
    render: (item) => {
      return (
        <div>
          <img
            style={{ height: "50px", marginRight: "10px" }}
            src={item.photo_url}
            alt={`order-image${item.id}`}
          />{" "}
          {item.name}
        </div>
      );
    },
  },
  {
    title: "Quantity",
    dataIndex: "quantity",
    key: "quantity",
  },
  {
    title: "Price",
    dataIndex: "price",
    key: "price",
    render: (price) => `$${price}`,
  },
];

export default class OrderDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      orderStatus: "ORDER_PLACED",
      order: {},
    };
  }
  componentDidMount() {
    this.getOrder();
  }

  getOrder = async () => {
    const id = this.props.match.params.orderId;

    if (id) {
      const order = await OrderService.getOrder(id);
      this.setState({
        order,
        loading: false,
      });
    } else {
      this.setState({
        loading: true,
      });
    }
  };

  changeOrderStatus = async (status) => {
    const id = this.props.match.params.orderId;
    this.setState({
      loading: true,
    });
    const payload = {
      order_num: id,
      status: status,
    };
    if (id) {
      const orderStatus = await OrderService.changeOrderStatus(payload);
      this.getOrder();
    } else {
      this.setState({
        loading: false,
      });
    }
  };

  getCurrentStatus = (order_status) => {
    let option;
    if (order_status === "ORDER_PLACED") {
      option = 0;
    } else if (
      order_status == "ACCEPTED" ||
      order_status == "REJECTED"
    ) {
      option = 1;
    } else if (
      order_status == "READY"
    ) {
      option = 2;
    } else if (
      order_status == "FULFILLED"
    ) {
      option = 3;
    } else {
      option = 0;
    }
    return option;
  };

  getNextStatus = ({ is_picked_up, order_status }) => {
    let actionObj;
    if (order_status == "ACCEPTED" || order_status == "REJECTED") {
      actionObj = {
        label: is_picked_up ? "Ready for pickup" : "In Transit",
        action: "PREPARING",
      };
    } else if (
      order_status == "PREPARING"
    ) {
      actionObj = {
        label: is_picked_up ? "Picked Up" : "Delivered",
        action: "READY",
      };
    } else if (
      order_status == "READY"
    ) {
      actionObj = {
        label: is_picked_up ? "Picked Up" : "Delivered",
        action: "FULFILLED",
      };
    }
    return actionObj;
  };

  renderStep = ({ is_picked_up, order_status }) => {
    let current = this.getCurrentStatus(order_status);
    let status = (() => {
      let code;
      code = "process";
      if (order_status && order_status == "REJECTED") {
        code = "error";
      }
      if (current == "3") {
        code = "finish";
      }
      return code;
    })();
    return (
      <Steps current={current} status={status}>
        <Step title="Order Placed" />
        <Step title="Order Accepted / Rejected" />
        {is_picked_up ? (
          <>
            <Step title="Ready for pickup" />
            <Step title="Picked Up" />
          </>
        ) : (
          <>
            <Step title="In Transit" />
            <Step title="Delivered" />
          </>
        )}
      </Steps>
    );
  };

  render() {
    const { order } = this.state;
    let actionButtonObj = this.getNextStatus(order);
    return (
      <Layout style={{ padding: "0 24px 24px" }}>
        <Content
          className="site-layout-background"
          style={{
            padding: 24,
            margin: "16px 0px",
            minHeight: 280,
          }}
        >
          <PageHeader
            title={`Order Number - ${order.order_num}`}
            subTitle={`Delivery Type: ${
              order.is_picked_up ? "PICKUP" : "DELIVERY"
            }`}
            onBack={() => this.props.history.goBack()}
          >
            <br />
            <br />
            <Row style={{ textAlign: "left" }}>
              <Col
                xs={{ span: 24, offset: 0 }}
                lg={{ span: 2, offset: 0 }}
                md={{ span: 12 }}
              >
                <Statistic title="Price" prefix="$" value={order.price} />
              </Col>
              <Col
                xs={{ span: 24, offset: 0 }}
                lg={{ span: 6, offset: 0 }}
                md={{ span: 12 }}
              >
                <Card title={order.customer?.customer_name}>
                  <p>{order.customer?.email}</p>
                  <p>{order.customer?.address_field1}</p>
                  <p>{order.customer?.address_field2}</p>
                  <p>
                    {order.customer?.city} {order.customer?.state_province}{" "}
                    {order.customer?.postal_code}
                  </p>
                </Card>
              </Col>
            </Row>
          </PageHeader>
          <br />
          <br />
          <Row style={{ textAlign: "left" }}>
            <Col
              xs={{ span: 24, offset: 0 }}
              lg={{ span: 6, offset: 0 }}
              md={{ span: 12 }}
              style={{
                display:
                  this.getCurrentStatus(order.order_status) >= 1
                    ? "none"
                    : "block",
              }}
            >
              <Button
                className="success"
                onClick={() => this.changeOrderStatus("ACCEPTED")}
              >
                Accept Order
              </Button>
              <Button
                style={{ marginLeft: 8 }}
                className="danger"
                onClick={() => this.changeOrderStatus("REJECTED")}
              >
                Reject Order
              </Button>
            </Col>
            <Col
              xs={{ span: 24, offset: 0 }}
              lg={{ span: 6, offset: 0 }}
              md={{ span: 12 }}
              style={{
                display:
                  this.getCurrentStatus(order.order_status) >= 1
                    ? "block"
                    : "none",
              }}
            >
              <Button
                className="success"
                onClick={() =>
                  this.changeOrderStatus(`${actionButtonObj.action}`)
                }
                style={{
                  display:
                    order && order.order_status == "REJECTED"
                      ? "none"
                      : order.order_status == "FULFILLED"
                      ? "none"
                      : "block",
                }}
              >
                {actionButtonObj.label}
              </Button>
            </Col>
          </Row>
          <br />
          <br />

          <div>
            {this.renderStep(order)}
            <h3></h3>
          </div>
          <br />
          <br />
          <Table columns={columns} dataSource={order.order_items} />
        </Content>
        <R2Footer />
      </Layout>
    );
  }
}
